










import { Vue, Component, Watch } from "vue-property-decorator";
import TicketSystemRoot from "./components/ticket-system-root/TicketSystemRoot.vue"
import TicketDashboard from "./components/TicketDashboard.vue"
import {TicketService} from "@share/common/services/ticket/TicketService";
import {TicketTableHelper} from "./helpers/TicketTableHelper";
import { TableHelperInterface } from "@common/table/interfaces/TableHelper";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { getIsTicketAdmin, getTicketType } from "@share/common/helpers/ticketSystemHelpers";

@Component({ components: { TicketSystemRoot, TicketDashboard }})

export default class TicketSystem extends Vue {
    ticketService: TicketService;
    ticketHelper: TableHelperInterface;

    created(): void {
        this.ticketService = new TicketService(this.$store, this.isTicketAdmin);
        this.ticketHelper = Vue.observable(new TicketTableHelper(this.ticketService, this.ticketsType, this.$store));
    }

    get ticketsType() {
        return getTicketType(this.$route?.name);
    }

    get isTicketAdmin() {
        return getIsTicketAdmin(this.$route?.name, this.$store.getters["groupIds"], this.ticketsType)
    }

    @Watch('showDashboard', { immediate: true })
    watchRoute(value: boolean) {
        if(value) {
            this.$store.dispatch("setPageTitle", this.$t("common.ticketSystemDashboard"));
        }
    }

    get showDashboard() {
        return this.$route.name === RouteNamesEnum.ticketSystemDashboard;
    }
}
